export const float32ArrayToWav = (audio: Float32Array, sampleRate = 16000): Blob => {
  // WAV 파일 헤더 생성
  const buffer = new ArrayBuffer(44 + audio.length * 2);
  const view = new DataView(buffer);

  // "RIFF" 청크 디스크립터
  writeString(view, 0, 'RIFF');
  view.setUint32(4, 36 + audio.length * 2, true);
  writeString(view, 8, 'WAVE');

  // "fmt " 서브청크
  writeString(view, 12, 'fmt ');
  view.setUint32(16, 16, true); // 서브청크 크기
  view.setUint16(20, 1, true); // 오디오 포맷 (1 = PCM)
  view.setUint16(22, 1, true); // 채널 수
  view.setUint32(24, sampleRate, true); // 샘플레이트
  view.setUint32(28, sampleRate * 2, true); // 바이트 레이트
  view.setUint16(32, 2, true); // 블록 얼라인
  view.setUint16(34, 16, true); // 비트 퍼 샘플

  // "data" 서브청크
  writeString(view, 36, 'data');
  view.setUint32(40, audio.length * 2, true);

  // PCM 오디오 데이터를 리틀 엔디안으로 기록
  const volume = 1; // 볼륨 스케일링 (필요에 따라 조정)
  for (let i = 0; i < audio.length; i++) {
    const s = Math.max(-1, Math.min(1, audio[i] * volume));
    const sample = s < 0 ? s * 0x8000 : s * 0x7FFF; // 16비트 PCM 스케일링
    view.setInt16(44 + i * 2, sample, true);
  }

  return new Blob([buffer], { type: 'audio/wav' });
};

// 문자열을 DataView에 쓰는 헬퍼 함수
export const writeString = (view: DataView, offset: number, string: string) => {
  for (let i = 0; i < string.length; i++) {
    view.setUint8(offset + i, string.charCodeAt(i));
  }
};